import { Controller } from '@hotwired/stimulus'

export class TripCountdownController extends Controller {
  static classes = ['hidden']
  static values = { startDate: String }
  static targets = ['count', 'label']

  connect () {
    // Publishing morphs the stable dashboard card and restores this host's
    // server-rendered hidden state without reconnecting the controller.
    this.updateAfterTurboRender = () => this.update()
    document.addEventListener('turbo:render', this.updateAfterTurboRender)
    this.update()
  }

  disconnect () {
    document.removeEventListener('turbo:render', this.updateAfterTurboRender)
    clearTimeout(this.timeout)
  }

  update () {
    clearTimeout(this.timeout)
    const startDate = this.parseDate(this.startDateValue)
    if (!startDate) return this.hide()

    const now = new Date()
    const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate())
    const departure = Date.UTC(startDate.year, startDate.month - 1, startDate.day)
    const days = Math.round((departure - today) / 86_400_000)
    if (days <= 0) return this.hide()

    this.countTarget.textContent = days
    this.labelTarget.textContent = `${days === 1 ? 'Day' : 'Days'} until departure`
    this.element.classList.remove(this.hiddenClass)
    this.timeout = setTimeout(() => this.update(), this.msUntilNextMidnight(now))
  }

  parseDate (value) {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value)
    if (!match) return null

    const [year, month, day] = match.slice(1).map(Number)
    const date = new Date(Date.UTC(year, month - 1, day))
    return date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day
      ? { year, month, day }
      : null
  }

  hide () {
    this.element.classList.add(this.hiddenClass)
  }

  msUntilNextMidnight (now) {
    const midnight = new Date(now)
    midnight.setHours(24, 0, 0, 0)
    return midnight - now
  }
}

export default TripCountdownController
